import React from 'react'
import './Welcome.css'
import background from './images/welcome.jpg'
import LaptopMacIcon from '@material-ui/icons/LaptopMac';

function Welcome() {
  return (
    <div className="welcome">
      <div className="welcome__container">
        <div className="image" style={{backgroundImage: `url('${background}')`}}></div>
        <h1>Keep your phone connected</h1>
        <p>WhatsApp connects to your phone to sync messages. To reduce data usage, connect <br /> your phone to Wi-Fi.</p>
        <hr />
        <p><LaptopMacIcon />Make calls from desktop with WhatsApp for Windows. <span>Get it here</span></p>
      </div>
    </div>
  )
}

export default Welcome
